import { create } from 'zustand';

/**
 * H-2 — 마감 CTA를 윈도우 하단 footer band로 승격하기 위한 경량 채널.
 *
 * footer band(`TodaySealedFooterConnected`, windowContent 바깥)와 마감 로직 소유자
 * (`TodayMemo`, windowContent 안)는 분리된 형제 서브트리라 직접 통신할 수 없다.
 * 이 store가 그 사이를 잇는다 — 단, 마감 로직(flush→저장→closeDay→submit)과
 * `CloseDayWizard`는 여전히 `TodayMemo`가 소유한다. footer는 "열어줘" 신호만 보내고
 * 버튼 표시에 필요한 메타(busy/submitted/canClose)만 구독한다. 이렇게 해야 메모
 * 저장(flush) 보장이 깨지지 않는다.
 *
 * 패턴 선례: `useToastStore`(ephemeral zustand), `QuestEditContext`(액션+메타 분리).
 */
interface TodayCloseState {
  /** footer 버튼 클릭 시 ++. TodayMemo가 변화를 구독해 마감창을 연다(열기 신호). */
  openNonce: number;
  /** 마감 진행 중(closeDay/submit pending) — 버튼 disabled. TodayMemo가 publish. */
  busy: boolean;
  /** SUBMITTED 상태 — 버튼 라벨 분기('오늘 일지 마감'/'수정 후 다시 마감'). */
  submitted: boolean;
  /** 오늘 업무일지 존재 = 마감 가능. false면 footer 버튼 미표시. */
  canClose: boolean;
  /** footer 버튼 → 마감창 열기 요청. */
  requestOpen: () => void;
  /** TodayMemo → 버튼 메타 publish. */
  publishMeta: (meta: { busy: boolean; submitted: boolean; canClose: boolean }) => void;
  /** TodayMemo 언마운트 시 메타 초기화(stale 버튼 방지). */
  reset: () => void;
}

export const useTodayCloseStore = create<TodayCloseState>((set) => ({
  openNonce: 0,
  busy: false,
  submitted: false,
  canClose: false,
  requestOpen: () => set((s) => ({ openNonce: s.openNonce + 1 })),
  publishMeta: ({ busy, submitted, canClose }) => set({ busy, submitted, canClose }),
  reset: () => set({ busy: false, submitted: false, canClose: false }),
}));
